import { format, isValid, parse } from 'date-fns';
import { formatDate, formatDateTime, formatTime } from '@/utils/format';

export function parseDateValue(value?: string | null): Date | null {
  if (!value) return null;
  const parsed = parse(value, 'yyyy-MM-dd', new Date());
  return isValid(parsed) ? parsed : null;
}

export function formatDateValue(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function parseDateTimeLocal(value?: string | null): Date | null {
  if (!value) return null;
  const parsed = parse(value, "yyyy-MM-dd'T'HH:mm", new Date());
  return isValid(parsed) ? parsed : null;
}

export function formatDateTimeLocal(date: Date): string {
  return format(date, "yyyy-MM-dd'T'HH:mm");
}

/** Display-only label for date fields using company format policy. */
export function displayDate(value?: string | null): string {
  if (!value) return '';
  return formatDate(value);
}

/** Display-only label for datetime fields using company format policy. */
export function displayDateTime(value?: string | null): string {
  if (!value) return '';
  if (value.includes('T')) return formatDateTime(value);
  return displayDate(value);
}

/** Parse 24h time string `HH:mm` or `HH:mm:ss`. */
export function parseTimeValue(value?: string | null): { hour: number; minute: number } | null {
  if (!value) return null;
  const match = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(value.trim());
  if (!match) return null;
  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;
  return { hour, minute };
}

export function formatTimeValue(hour: number, minute: number): string {
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}

/** Display-only label for wall-clock times using company time format policy. */
export function displayTime(value?: string | null): string {
  if (!value) return '';
  return formatTime(value);
}
